exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* sizes */\n/* colors */\n.TabItem__TabItem__ntrfI {\n  display: block;\n  padding: 10px 15px;\n  cursor: pointer;\n  border-radius: 4px 4px 0 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-bottom: -1px; }\n  .TabItem__TabItem__ntrfI + .TabItem__TabItem__ntrfI {\n    margin-left: 2px; }\n  .TabItem__TabItem__ntrfI:hover {\n    background-color: #E9ECEE;\n    border-bottom-color: transparent; }\n  .TabItem__TabItem__ntrfI.TabItem__active__67z9I {\n    color: #495056;\n    background-color: #FFFFFF;\n    border: 1px solid #DEE2E5;\n    border-bottom-color: transparent;\n    cursor: default; }\n", ""]);

// exports
exports.locals = {
	"TabItem": "TabItem__TabItem__ntrfI",
	"active": "TabItem__active__67z9I"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/components/atoms/TabItem/TabItem.scss
// module id = 204
// module chunks = 0